function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var normalWeightRegexp = /font-weight:\s*normal/;
var blockTagNames = ['P', 'OL', 'UL'];

var isBlockElement = function isBlockElement(element) {
  return element && blockTagNames.includes(element.tagName);
};

var normalizeEmptyLines = function normalizeEmptyLines(doc) {
  Array.from(doc.querySelectorAll('br')).filter(function (br) {
    return isBlockElement(br.previousElementSibling) && isBlockElement(br.nextElementSibling);
  }).forEach(function (br) {
    var _br$parentNode;

    (_br$parentNode = br.parentNode) === null || _br$parentNode === void 0 ? void 0 : _br$parentNode.removeChild(br);
  });
};

var normalizeFontWeight = function normalizeFontWeight(doc) {
  Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter(function (node) {
    var _node$getAttribute;

    return (_node$getAttribute = node.getAttribute('style')) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.match(normalWeightRegexp);
  }).forEach(function (node) {
    var _node$parentNode;

    var fragment = doc.createDocumentFragment();
    fragment.append.apply(fragment, _toConsumableArray(node.childNodes));
    (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : _node$parentNode.replaceChild(fragment, node);
  });
};

export default function normalize(doc) {
  if (doc.querySelector('[id^="docs-internal-guid-"]')) {
    normalizeFontWeight(doc);
    normalizeEmptyLines(doc);
  }
}